import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";

import type { StandaloneLicensePayload } from "modules/LocationLicenseOverview/hooks";

export const useSelectedStandaloneLicenceUpdateMutation = () =>
  useTypedMutation<StandaloneLicensePayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/licenses/standalone/update", payload, ENV.exactBaseURL)).data,
    onSuccess: ({ license }) => {
      const licenses = typedQueryClient.getQueryData(LocationLicenseOverviewKeys.licenses);
      if (!licenses) return;

      const standaloneLicenseIdx = licenses.standalone_licenses?.findIndex(standaloneLicense => standaloneLicense.id === license.id) ?? -1;
      if (standaloneLicenseIdx === -1) return;

      typedQueryClient.setQueryData(LocationLicenseOverviewKeys.licenses, {
        ...licenses,
        standalone_licenses: licenses.standalone_licenses?.with(standaloneLicenseIdx, license)
      });
    }
  });
